export const getLocations = locations => {
  return locations?.map(location => ({ label: location.name, value: location.id }))
}
